import { WrapperOption } from '@ngx-formly/core/lib/models';
import { SectionWrapperComponent } from './wrappers/section-wrapper/section-wrapper.component';

export const configurableFormWrappers: WrapperOption[] = [
  { name: 'section', component: SectionWrapperComponent },
];
